// covered-by: frontends/carrie/src/ask-v2/review/__tests__/AskV2ReviewWorkspace.test.tsx
import { createContext, useContext, useMemo } from "react";

import { type AskV2ReviewLeftPane } from "./useAskV2ReviewWorkspace";

type AskV2ReviewComposerContextValue = {
  onRemoveCommentContext: (id: string) => void;
  leftPane?: AskV2ReviewLeftPane;
  commentCount?: number;
  onPaneChange?: (pane: AskV2ReviewLeftPane) => void;
  /** Bumps when a finding is selected so the composer can place the caret. */
  composerFocusNonce?: number;
};

const AskV2ReviewComposerContext =
  createContext<AskV2ReviewComposerContextValue | null>(null);

export function AskV2ReviewComposerProvider({
  onRemoveCommentContext,
  leftPane,
  commentCount,
  onPaneChange,
  composerFocusNonce,
  children,
}: {
  onRemoveCommentContext: (id: string) => void;
  leftPane?: AskV2ReviewLeftPane;
  commentCount?: number;
  onPaneChange?: (pane: AskV2ReviewLeftPane) => void;
  composerFocusNonce?: number;
  children: React.ReactNode;
}) {
  const value = useMemo(
    () => ({
      onRemoveCommentContext,
      leftPane,
      commentCount,
      onPaneChange,
      composerFocusNonce,
    }),
    [
      onRemoveCommentContext,
      leftPane,
      commentCount,
      onPaneChange,
      composerFocusNonce,
    ],
  );
  return (
    <AskV2ReviewComposerContext.Provider value={value}>
      {children}
    </AskV2ReviewComposerContext.Provider>
  );
}

export function useAskV2ReviewComposerContext() {
  return useContext(AskV2ReviewComposerContext);
}
